(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'UserContacts','$state','$http','$translate'];

    function HomeController ($scope, Principal, LoginService,UserContacts,$state,$http, $translate) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.escapeSingleQuote = escapeSingleQuote;
        vm.showEmailAlert = false;
        vm.mailIsMissing = false;
		vm.mailsAreEqual = false;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
           
        });
        
        $scope.$on('languageChange', function() {
            getServicesList(true);
            //col solo $state.reload(); qui funziona male, fa il reload prima che finisca il cambio lingua, non va bene.
        });

        getAccount();
          

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.account){
                	checkPersonalInformations(vm.account);
                	getServicesList();
                	getUserType();
                }
                else if(!vm.isAuthenticated()){
                	console.log("Redirecting to /landing/auth/");
                	window.location.href = "/landing/auth/"; 
                }
                	
            });
        }
        function register () {
            $state.go('register');
        }
        
        
        function getServicesList(force){
        	var currentLang=$translate.use();
        	$http.get('api/userServiceList?lang='+currentLang).then(function(result) {
                
        		if(result.status == 200){
        			$scope.userServices = result.data;
        			if (force) $state.reload();
        		}
                
            });

        }
        
        function getUserType(){
        	$http.get('api/userType').then(function(result) {
                
        		if(result.status == 200){
        			$scope.userType = result.data;
        		}
                
            });

        };
        
        function checkPersonalInformations(account){
        	if (account.login && account.login.indexOf("@") < 0) {
	        	UserContacts.get({}, function(result, headers) {
	    	   		vm.emailPersonale = result.email;
	    	   		if (!/^I\d+$/.test(account.login.toUpperCase()))
	    	   		if(vm.emailPersonale==null || vm.emailPersonale.length==0){
	    	   			vm.account.authorities = ['ROLE_SETTINGS'];
	    	   			$state.go('settings');
	    	   		}
	    	   		
	    	   	});
        	}
        }
        
        function escapeSingleQuote(stringa){
        	stringa = stringa ? stringa.replace(/'/g, "\\'") : '';
        	return stringa;
        }
    }
})();
